export enum OS {
  iOS = 'iOS',
  Android = 'Android'
}
